import React, { PureComponent } from "react";
import Template from "../components/template/Template";
import Navbar from "../components/template/Navbar";

class Dashboard extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="p-3">
        <div>dashboard</div>
      </div>
    );
  }
}

export default Dashboard;
